import { useContext, useMemo } from 'react';

import { XYChartDataContext } from '../context/XYChartData.context.js';
import {
  LINE_VARIANT,
  type LineSeriesToMetadata,
  type LineSeriesWithDatapoints,
} from '../types/xy-chart-internals.js';

export interface LineDataInternal {
  filteredSeriesWithDatapoints: LineSeriesWithDatapoints[];
  seriesToMetadata: LineSeriesToMetadata;
}

export const useLineData = () => {
  const context = useContext(XYChartDataContext);

  if (context === undefined) {
    throw new Error('useLineData must be used within a XYChartDataContext');
  }

  const filteredContext = useMemo(() => {
    return {
      seriesToMetadata: context.seriesToMetadata,
      filteredSeriesWithDatapoints: context.filteredSeriesWithDatapoints.filter(
        (series) => series.type === LINE_VARIANT,
      ),
    };
  }, [context]);

  return filteredContext as LineDataInternal;
};
